/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import classNames from 'classnames';
import { styled } from '@aibi-ui/core';
import { PaginationButtonProps } from './types';
import Icons from '../Icons';

const StyledLi = styled.li`
  display: flex !important;
  justify-content: center;
  align-items: center;
  border: none !important;
  width: 32px;
  height: 32px;
  span {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  svg {
    width: 16px;
    height: 16px;
    transform: rotate(-90deg);
    fill: none;
  }
  &:hover {
    border: none !important;
    background: transparent !important;
    svg {
      color: rgba(0, 0, 0, 0.9);
    }
  }
`;

export function Next({ disabled, onClick }: PaginationButtonProps) {
  return (
    <StyledLi className={classNames({ disabled })}>
      <span
        role="button"
        tabIndex={disabled ? -1 : 0}
        onClick={e => {
          e.preventDefault();
          if (!disabled) onClick(e);
        }}
      >
        <Icons.SelectArrow viewBox="0 0 16 16" />
      </span>
    </StyledLi>
  );
}
